import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router";
import { usePollTask } from "../../hooks/usePollTask";
import { useReportById } from "../../hooks/useReportHistory";

function ReportDebug() {
  const { id } = useParams();
  const reportQuery = useReportById(id);
  const shouldPoll =
    reportQuery.status !== "pending" &&
    reportQuery.data?.status !== "complete" &&
    reportQuery.data?.status !== "failed";
  const reportPollQuery = usePollTask(id, shouldPoll);
  const reportFromHistory = shouldPoll ? reportPollQuery.data : reportQuery.data;

  if (reportPollQuery.isLoading) {
    return (
      <div className="min-h-screen bg-background p-8">
        <div className="container mx-auto max-w-4xl">
          <p>Loading debug info...</p>
        </div>
      </div>
    );
  }

  const debugInfo = {
    id,
    pollQuery: {
      isLoading: reportPollQuery.isLoading,
      isError: reportPollQuery.isError,
      error: reportPollQuery.error ? reportPollQuery.error.message : null,
      data: reportPollQuery.data,
      status: reportPollQuery.status,
    },
    report: reportFromHistory,
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto p-8 max-w-6xl">
        <div className="mb-6">
          <Button variant="ghost" asChild>
            <Link to={`/v1/report/${id}`}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Report
            </Link>
          </Button>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Debug Information</CardTitle>
          </CardHeader>
          <CardContent>
            <pre className="text-xs overflow-x-auto bg-muted p-4 rounded-lg">
              {JSON.stringify(debugInfo, null, 2)}
            </pre>
          </CardContent>
        </Card>

        {reportFromHistory && (
          <Card className="mt-4">
            <CardHeader>
              <CardTitle>Full Report Data</CardTitle>
            </CardHeader>
            <CardContent>
              <pre className="text-xs overflow-x-auto bg-muted p-4 rounded-lg max-h-[600px] overflow-y-auto">
                {JSON.stringify(reportFromHistory, null, 2)}
              </pre>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}

export default ReportDebug;
